function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/* eslint semi: ["error", "never"]*/

/* eslint arrow-parens: ["error", "as-needed"]*/

/* eslint key-spacing: ["error", { "afterColon": true, "align": "value" }] */

/* eslint no-multi-spaces: ["error", { exceptions: { "ImportDeclaration": true,
                                       "VariableDeclarator": true  } }] */

/* eslint no-underscore-dangle: 0 */

/* eslint no-console: ["error", { allow: ["warn", "error", "log", "group", "groupEnd"] }] */
import Loader from '@engine/components/presentational/base/loader';
import React from 'react';
import TagsField from '@engine/components/presentational/base/tags-field';
import { applePayMerchantDomainRequest } from '@engine/actions/creators/apple-pay-merchant-registration';
import { connect } from 'react-redux';
import isFQDN from 'validator/lib/isFQDN';
var MIN_DOMAIN_LENGTH = 3;

var ApplePayMerchantRegistrationForm = /*#__PURE__*/function (_React$Component) {
  _inherits(ApplePayMerchantRegistrationForm, _React$Component);

  var _super = _createSuper(ApplePayMerchantRegistrationForm);

  function ApplePayMerchantRegistrationForm(props) {
    var _this;

    _classCallCheck(this, ApplePayMerchantRegistrationForm);

    _this = _super.call(this, props);
    _this.state = {
      domains: _this.props.contractDomains
    };
    return _this;
  }

  _createClass(ApplePayMerchantRegistrationForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var noOptionsMessageFor = function noOptionsMessageFor(inputValue) {
        return isFQDN(inputValue) ? inputValue : I18n.t('javascript.merchants.apple_pay_onboarding.invalid_domain_format');
      };

      return React.createElement("div", null, this.props.message && React.createElement("div", {
        className: this.alertClassName
      }, this.props.message), this.props.isSubmitting && React.createElement(Loader, {
        position: "horizontal-center",
        color: "refined-blue"
      }), React.createElement(TagsField, {
        label: I18n.t('javascript.merchants.apple_pay_onboarding.merchant_domains'),
        name: "merchant_domains",
        onChange: function onChange(value, name, action) {
          _this2.onMerchantDomainsChange(value, name, action);
        },
        isValidNewOption: this.isValidNewOption,
        noOptionsMessage: noOptionsMessageFor,
        value: this.state.domains,
        fieldWidth: 'col-lg-12 col-md-12 col-sm-12',
        isClearable: false,
        backspaceRemovesValue: false
      }));
    }
  }, {
    key: "isValidNewOption",
    value: function isValidNewOption(inputValue) {
      if (inputValue.length < MIN_DOMAIN_LENGTH) {
        return false;
      }

      return isFQDN(inputValue);
    }
  }, {
    key: "onMerchantDomainsChange",
    value: function onMerchantDomainsChange(values, name, _ref) {
      var action = _ref.action,
          removedValue = _ref.removedValue;
      this.setState(_objectSpread(_objectSpread({}, this.state), {}, {
        domains: values
      }));

      switch (action) {
        case 'remove-value':
          return this.props.applePayMerchantDomainRequest(this.props.url, 'DELETE', removedValue.value);

        default:
          return this.props.applePayMerchantDomainRequest(this.props.url, 'POST', values);
      }
    }
  }, {
    key: "alertClassName",
    get: function get() {
      return "alert ".concat(this.props.hasError ? 'alert-danger-light' : 'alert-warning-light', " alert-slim");
    }
  }]);

  return ApplePayMerchantRegistrationForm;
}(React.Component);

export default connect(function (state) {
  return {
    message: state.applePayMerchantRegistration.message,
    hasError: state.applePayMerchantRegistration.hasError,
    isSubmitting: state.applePayMerchantRegistration.isSubmitting
  };
}, {
  applePayMerchantDomainRequest: applePayMerchantDomainRequest
})(ApplePayMerchantRegistrationForm);